import { ButtonSize } from "@eworkit/iris";
import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { MEDIA_SIZE_MD, MEDIA_SIZE_SM } from "@/core/media";
import { Flex } from "@/eworkitComponents";
import { IrisRouteButton } from "@/infrastructure/Route";
import { router } from "@/views/router";

import "./_nav-buttons.scss";

interface INavButtonsProps {
  size?: ButtonSize;
}

export const NavButtons: FC<INavButtonsProps> = memo(({ size }) => {
  const { t } = useTranslation("public");
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const isMediumScreen = useMedia(MEDIA_SIZE_MD);

  const buttonSize = size || "md";

  return (
    <Flex innerMargin="sm" padding={isMediumScreen && !isSmallScreen ? [false, "md"] : undefined}>
      <IrisRouteButton
        path={router.get("login").path}
        variant="ghost"
        size={buttonSize}
        className="topbar__link-button">
        {t("LANDING_PAGE.BUTTON_LOGIN")}
      </IrisRouteButton>
      {!isSmallScreen && (
        <IrisRouteButton path={router.get("register-form").path} variant="primary" size={buttonSize}>
          {t("LANDING_PAGE.BUTTON_CREATE_ACCOUNT")}
        </IrisRouteButton>
      )}
    </Flex>
  );
});
